import React, { useState, useEffect } from "react";
import "../css/Colors.css";
import apiHelper from "../utils/apiHelper";
import LoadingSpinner from "../components/Common/LoadingSpinner";
import EventsDisplay from "../components/Events/EventsDisplay";
import "./Events.css";

const { FILE_NAMES } = require('../utils/constants');

function Events() {
  const [eventsData, setEventsData] = useState([]);
  const [filterTypes, setFilterTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDataEvents = async () => {
      try {
        const eventsResult = await apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.EVENTS);
        const res = eventsResult.fileContent;
        
        // prepare filters from data
        let s_months = new Set();
        let s_years = new Set();
        let s_categories = new Set();
        let s_eventtypes = new Set();
        let s_topics = new Set();

        res.forEach((event) => {
          // Handle date parsing with better error checking
          let date;
          try {
            const raw_date = new Date(event.EventDate);
            
            // Check if the original date is valid
            if (isNaN(raw_date.getTime())) {
              console.warn('Invalid EventDate for event:', event.Title || event.ID, 'Date:', event.EventDate);
              // Keep the original invalid date so it gets handled in the modal
              date = raw_date;
            } else {
              const hour = raw_date.getUTCHours();
              const shiftDay = hour >= 12 ? 1 : 0;

              date = new Date(
                Date.UTC(
                  raw_date.getUTCFullYear(),
                  raw_date.getUTCMonth(),
                  raw_date.getUTCDate() + shiftDay,
                  3
                )
              );
            }
          } catch (error) {
            console.warn('Error parsing EventDate for event:', event.Title || event.ID, 'Date:', event.EventDate, error);
            date = new Date(event.EventDate); // Fallback to basic parsing
          }

          event.EventDate = date;

          let formatter = new Intl.DateTimeFormat("en", { month: "long" });

          if (!isNaN(date.getTime())) {
            s_years.add(date.getUTCFullYear());
            s_months.add(formatter.format(new Date(2025, date.getMonth(), 1)));
          } else if (event.EventMonth) {
            const monthNum = parseInt(event.EventMonth);
            if (!isNaN(monthNum) && monthNum >= 1 && monthNum < 13) {
              s_months.add(formatter.format(new Date(2025, monthNum - 1, 1)));
            }
          }
          if (event.EventCategory) s_categories.add(event.EventCategory);
          if (event.InPerson_x002f_Virtual)
            s_eventtypes.add(event.InPerson_x002f_Virtual);
          
          // Convert Topics from comma-separated string to array
          if (event.Topics) {
            if (typeof event.Topics === 'string') {
              event.Topics = event.Topics.split(',').map(topic => topic.trim()).filter(topic => topic);
            }
            event.Topics.forEach((topic) => s_topics.add(topic));
          }
        });

        setFilterTypes([
          { id: "month", label: "Month", options: [...s_months] },
          {
            id: "year",
            label: "Year",
            options: [...s_years].sort((a, b) => {
              return parseInt(a) < parseInt(b) ? 1 : -1;
            }),
          },
          { id: "event_type", label: "Event Type", options: [...s_eventtypes] },
          {
            id: "topics",
            label: "Topics",
            options: [...s_topics],
            isMulti: true,
          },
          { id: "category", label: "Category", options: [...s_categories] },
        ]);

        res.sort((b, a) => new Date(b.EventDate) - new Date(a.EventDate));
        setEventsData(res);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err.message);
        setIsLoading(false);
      }
    };
    fetchDataEvents();
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <div className="container mt-10">
       
        {eventsData.length > 0 ? (
          <EventsDisplay eventsData={eventsData} filterTypes={filterTypes} />
        ) : (
          <div className="container no-events">
            <h4>No Events Available</h4>
          </div>
        )}
      </div>
    </div>
  );
}

export default Events;
